import { KPI } from '@/hooks/useCampaigns';

export const formatFilename = (name?: string): string => {
  if (!name) return 'campaign';

  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-');
};

export const formatKPI = (kpi: KPI): string => {
  return kpi.charAt(0).toUpperCase() + kpi.slice(1).toLowerCase();
};
